export enum AppointmentStatus {
  UPCOMING = 'UPCOMING',
  IN_CONSULTATION = 'IN_CONSULTATION',
  WAITING_ROOM = 'WAITING_ROOM',
  JUSTIFIED_ABSENCE = 'JUSTIFIED_ABSENCE',
  UNJUSTIFIED_ABSENCE = 'UNJUSTIFIED_ABSENCE',
  SEEN = 'SEEN',
}
